<div class="bar" style="--margin-bottom: {{ marginBottom() }}px;">
  <div class="left">
    <ng-content select="[left]"></ng-content>
  </div>

  <div class="right">
    <ng-content select="[right]"></ng-content>
  </div>
</div>
